
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/causes/[causeId]",
      function () {
        return require("private-next-pages/causes/[causeId].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/causes/[causeId]"])
      });
    }
  